'use client';
import React, { useEffect, useState } from 'react';
import AppShell from '@/components/AppShell';
import EntryPointContent from './components/EntryPointContent';
import SmartDashboard from './components/SmartDashboard';

export default function EntryPointPage() {
  const [showDashboard, setShowDashboard] = useState<boolean | null>(null);

  useEffect(() => {
    const fromDashboard = sessionStorage.getItem('from_dashboard');
    setShowDashboard(!fromDashboard);
  }, []);

  // Avoid flash before sessionStorage is read
  if (showDashboard === null) return null;

  return (
    <AppShell>
      {showDashboard ? <SmartDashboard /> : <EntryPointContent />}
    </AppShell>
  );
}